import {GenericHttpError} from '../errors';

export function get<T>(url: string, authorizationToken: string): Promise<T> {
	return fetch(url, {
		method: 'GET',
		headers: new Headers({...getAuthorizationTokenHeader(authorizationToken)}),
	}).then(res => handleResponse<T>(res));
}

export function post<T>(url: string, data: {}, authorizationToken: string): Promise<T> {
	return fetch(url, {
		method: 'POST',
		headers: new Headers({
			'Content-Type': 'application/json',
			...getAuthorizationTokenHeader(authorizationToken),
		}),
		body: JSON.stringify(data),
	}).then(res => handleResponse<T>(res));
}

export function postForm<T>(url: string, data: {}, authorizationToken: string): Promise<T> {
	return fetch(url, {
		method: 'POST',
		headers: new Headers({
			...getAuthorizationTokenHeader(authorizationToken),
		}),
		body: buildFormData(data),
	}).then(res => handleResponse<T>(res));
}

function getResult(res: Response): Promise<any> {
	const contentType = res.headers.get('Content-Type');
	if (res.status === 204) {
		return Promise.resolve();
	} else if (contentType && contentType.startsWith('application/json')) {
		return res.json();
	} else if (contentType && contentType.startsWith('application/zip')) {
		return res.blob();
	} else {
		return res.text();
	}
}

function handleResponse<T>(res: Response): Promise<T> {
	return getResult(res).then(result => {
		if (res.ok) {
			return result;
		} else {
			throw new GenericHttpError(res.status, res.statusText, result);
		}
	});
}

function getAuthorizationTokenHeader(authorizationToken?: string) {
	return authorizationToken ? {Authorization: authorizationToken} : {};
}

function buildFormData(data: {[key: string]: any}) {
	const formData = new FormData();
	Object.keys(data).forEach(key => {
		const keyData = data[key];
		if (Array.isArray(keyData)) {
			(keyData as any[]).forEach(element => {
				formData.append(key, element);
			});
		} else {
			formData.append(key, keyData);
		}
	});
	return formData;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/api/http.ts